/*
 * Applies discount codes from a `?discount=CODE1,CODE2` landing URL via
 * /cart/update.js. That endpoint replaces the cart's whole code list, so the
 * codes already on the cart are read first and sent back alongside the new ones.
 * Codes Shopify reports as applicable:false are kept — that flag also covers
 * valid codes whose conditions (e.g. a qualifying product) aren't met yet.
 * Stacking only works for discounts set in admin to combine with each other.
 */
(function () {
  'use strict';

  var paramName = 'discount';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function parseCodes(value) {
    var seen = {};
    return String(value || '')
      .split(',')
      .map(function (code) { return code.trim(); })
      .filter(function (code) {
        var key = code.toUpperCase();
        if (!code || seen[key]) return false;
        seen[key] = true;
        return true;
      });
  }

  function requestCart(path, options) {
    return fetch(root + path, options).then(function (res) {
      if (!res.ok) throw new Error(path + ' responded ' + res.status);
      return res.json();
    });
  }

  function stripParam() {
    var url = new URL(window.location.href);
    url.searchParams.delete(paramName);
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }

  function refreshCartDrawer(cart) {
    if (!cart.item_count || typeof reloadAjaxCartItemUsingCartAjaxObject !== 'function') return;
    try {
      reloadAjaxCartItemUsingCartAjaxObject(cart);
      if (typeof progressBar === 'function') progressBar();
    } catch (err) {
      console.warn('discount-link: cart drawer refresh failed', err);
    }
  }

  function applyCodes(urlCodes) {
    requestCart('cart.js', { headers: { Accept: 'application/json' } })
      .then(function (cart) {
        var existing = (cart.discount_codes || []).map(function (entry) { return entry.code; });
        var merged = parseCodes(existing.concat(urlCodes).join(','));
        if (merged.length === existing.length) return cart;
        return requestCart('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: merged.join(',') })
        });
      })
      .then(function (cart) {
        stripParam();
        refreshCartDrawer(cart);
      })
      .catch(function (err) {
        console.warn('discount-link: applying codes failed', err);
      });
  }

  var urlCodes = parseCodes(new URLSearchParams(window.location.search).get(paramName));
  if (urlCodes.length) applyCodes(urlCodes);
})();
